var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('TableComponent',{attrs:{"section":"transaction.Transaction","sectionRoot":"transaction_list","moduleName":"Transaction"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }